import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ChargepointType } from './chargepoints-api.service';

const HOST = environment.serverUrl;
const TRACES_API_URL = HOST + '/traces';

export interface Trace {
  type: string;
  chargePointId: string;
  time: Date;
  name: string;
  payload: any;
  errorCode?: string;
}

export interface TraceSearchCriteria {
  chargepointId?: string;
  type?: string;
  types?: ChargepointType[];
  from?: Date;
  to?: Date;
  errorOnly?: boolean;
  page?: number;
  size?: number;
}

export interface TraceSearchResult {
  traces: Trace[];
  total: number;
}

function reviveTrace(trace: Trace): Trace {
  trace.time = trace.time ? new Date(trace.time) : new Date(0);
  return trace;
}

@Injectable({ providedIn: 'root' })
export class TracesApiService {

  constructor(private http: HttpClient) { }

  public searchTraces(searchCriteria: TraceSearchCriteria): Observable<TraceSearchResult> {
    return this.http.post<TraceSearchResult>(`${TRACES_API_URL}/search`, {...searchCriteria}, { responseType: 'json' })
      .pipe(
        map(result => ({
          total: result.total ?? 0,
          traces: (result.traces ?? []).map(reviveTrace)
        }))
      );
  }
}
